
<template>
    <div v-if="wallet_id" class="w-full flex flex-column">
        <div class="flex flex-row gap-2">
            <Button v-if="isUserInGroup('admin_accounts_billing', accessCodes)" label="Пополнить" @click="openPopup('topup')" size="small" :disabled="loading || !wallet_id" icon="pi pi-arrow-down" iconPos="right" severity="success" class="border-none"/>
            <Button v-if="isUserInGroup('admin_accounts_billing', accessCodes)" label="Списать" @click="openPopup('withdraw')" size="small" :disabled="loading || !wallet_id" icon="pi pi-arrow-up" iconPos="right" severity="warn"/>
            <Button v-if="isUserInGroup('admin_accounts_billing', accessCodes)" label="Конвертация" @click="openPopup('transfer')" size="small" :disabled="loading || !wallet_id" icon="pi pi-sync" iconPos="right" severity="info"/>
        </div>

        <!--ПОПОЛНЕНИЕ-->
        <Dialog header="Пополнить" modal v-if="isUserInGroup('admin_accounts_billing', accessCodes)" v-model:visible="displayTopup"
            class="flex flex-column border-none"
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }"
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">

            <div class="w-full flex flex-column gap-3">
                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма:</span>
                    <InputGroup>
                        <InputNumber v-model="topupAmount" :min="0.0000001" :max="100000000" :maxFractionDigits="6" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                </div>

                <div v-if="hasFinId(wallet_id)" class="w-full flex flex-column gap-2">
                    <div class="flex">
                        <ToggleButton v-model="addToAdeskTopup" class="w-24" onLabel="Добавить в Adesk ✅️️️️️️️" offLabel="Добавить в Adesk" size="small"/>
                    </div>
                    <div v-if="addToAdeskTopup" class="w-full flex flex-column gap-2">
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Статья:</span>
                            <Select v-model="selectedArticleTopup" :options="articleOptions(1)" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите статью" class="w-full border-2 border-round-lg" />
                        </div>
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Поставщик:</span>
                            <Select v-model="selectedContractorTopup" :options="contractorOptions" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите поставщика" class="w-full border-2 border-round-lg" />
                        </div>
                    </div>
                </div>

                <div class="w-full mb-3">
                    <span class="flex text-600 mb-2 text-sm">Описание:</span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3"
                        :value="topupDescription"
                        @input="topupDescription = $event.target.value"
                        placeholder="Пополнение кошелька админом"
                        style="resize: none !important; font-family: inherit;"
                    />
                </div>
            </div>

            <template #footer>
                <Button label="Пополнить" @click='topup()' :disabled="topupDisabled" :loading="loading"/>
            </template>
        </Dialog>

        <!--СПИСАНИЕ-->
        <Dialog header="Списать" modal v-if="isUserInGroup('admin_accounts_billing')" v-model:visible="displayWithdraw"
            class="flex flex-column border-none"
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }"
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">

            <div class="w-full flex flex-column gap-3">
                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма:</span>
                    <InputGroup>
                        <InputNumber v-model="withdrawAmount" :min="0.0000001" :max="currentAccountBalance || 100000000" :maxFractionDigits="6" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                    <div class="flex justify-content-end">
                        <Button label="MAX" size="small" severity="info" text class="p-1 text-xs" @click="setMaxWithdrawAmount" />
                    </div>
                </div>

                <div v-if="hasFinId(wallet_id)" class="w-full flex flex-column gap-2">
                    <div class="flex">
                        <ToggleButton v-model="addToAdeskWithdraw" class="w-24" onLabel="Добавить в Adesk ✅️️️️️️️" offLabel="Добавить в Adesk" size="small"/>
                    </div>
                    <div v-if="addToAdeskWithdraw" class="w-full flex flex-column gap-2 mt-2">
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Статья:</span>
                            <Select v-model="selectedArticleWithdraw" :options="articleOptions(2)" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите статью" class="w-full border-2 border-round-lg" />
                        </div>
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Поставщик:</span>
                            <Select v-model="selectedContractorWithdraw" :options="contractorOptions" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите поставщика" class="w-full border-2 border-round-lg" />
                        </div>
                    </div>
                </div>

                <div class="w-full mb-3">
                    <span class="flex text-600 mb-2 text-sm">Описание:</span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3"
                        :value="withdrawDescription"
                        @input="withdrawDescription = $event.target.value"
                        placeholder="Списание средств админом"
                        style="resize: none !important; font-family: inherit;"
                    />
                </div>
            </div>

            <template #footer>
                <Button label="Списать" @click='withdraw()' :disabled="withdrawDisabled" :loading="loading" class="bg-orange-500 border-orange-500 text-white"/>
            </template>
        </Dialog>

        <!--КОНВЕРТАЦИЯ-->
        <Dialog header="Конвертация" modal v-if="isUserInGroup('admin_accounts_billing')" v-model:visible="displayTransfer" 
            class="flex flex-column border-none" 
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }"
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">

            <div v-if="transferLoading" class="w-full flex flex-column gap-3">
                <Skeleton height="3rem" class="border-round-xl" />
                <Skeleton height="3rem" class="border-round-xl" />
                <Skeleton height="4rem" class="border-round-xl" />
                <Skeleton height="4rem" class="border-round-xl" />
                <Skeleton height="8rem" class="border-round-xl" />
            </div>

            <div v-else class="w-full flex flex-column gap-3">
                <div class="w-full flex flex-column gap-2 px-2 py-3 surface-100 border-round-lg">
                    <div class="w-full flex flex-column gap-1">
                        <span class="flex text-600 text-sm">Со счета:</span>
                        <Select :modelValue="fromAccountId" :options="fromAccountOption ? [fromAccountOption] : []" optionLabel="label" optionValue="id" :disabled="true"
                            placeholder="Текущий счет" class="w-full border-2 border-round-xl" />
                    </div>

                    <div class="w-full flex flex-column gap-1">
                        <span class="flex text-600 text-sm">На счет:</span>
                        <Select v-model="toAccountId" :options="toAccountOptions" optionLabel="label" optionValue="id"
                            placeholder="Выберите счет" class="w-full border-2 border-round-xl">
                            <template #option="option">
                                <div class="flex flex-row text-sm gap-1 justify-content-between align-items-center">
                                    <span class="flex">{{ option.option.label }}</span>
                                </div>
                            </template>
                        </Select>
                    </div>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма отправки ({{ fromCurrencyCode || '-' }}):</span>
                    <InputGroup class="flex">
                        <InputNumber v-model="transferAmount" :min="0.0000001" :max="currentAccountBalance || 100000000" :maxFractionDigits="6" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                    <div class="flex justify-content-end">
                        <Button label="MAX" size="small" severity="info" text class="p-1 text-xs" @click="setMaxTransferAmount" />
                    </div>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Курс ({{ fromCurrencyCode || '-' }}/{{ toCurrencyCode || '-' }}):</span>
                    <InputGroup class="flex">
                        <InputNumber v-model="transferRate" :min="0.0000001" :max="100000000" :maxFractionDigits="18" size="large"
                            class="w-full border-2 surface-border border-round-xl pl-2 overflow-hidden" />
                    </InputGroup>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Комиссия (%):</span>
                    <InputGroup class="flex">
                        <InputNumber v-model="transferCommission" :min="0" :max="1000" :maxFractionDigits="4" size="large"
                            class="w-full border-2 surface-border border-round-xl pl-2 overflow-hidden" />
                    </InputGroup>
                    <div class="flex justify-content-end flex-wrap gap-1">
                        <Button label="0%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(0)" />
                        <Button label="1%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(1)" />
                        <Button label="2%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(2)" />
                        <Button label="3%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(3)" />
                        <Button label="4%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(4)" />
                        <Button label="5%" size="small" severity="info" text class="p-1 text-xs" @click="setTransferCommission(5)" />
                    </div>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Итоговый курс:</span>
                    <span class="text-sm font-medium surface-100 border-round-lg px-3 py-2">
                        {{ formattedTransferEffectiveRate }} {{ fromCurrencyCode || '-' }}/{{ toCurrencyCode || '-' }}
                    </span>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма к получению ({{ toCurrencyCode || '-' }}):</span>
                    <InputGroup class="flex">
                        <InputNumber v-model="transferReceiveAmount" :min="0" :max="100000000" :maxFractionDigits="6" size="large" :disabled="true"
                            class="w-full border-2 surface-border border-round-xl pl-2 overflow-hidden" />
                    </InputGroup>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Описание:</span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2"
                        :value="transferDescription"
                        @input="transferDescription = $event.target.value"
                        placeholder="Перевод между счетами админом"
                        style="resize: none !important; font-family: inherit;"
                    />
                    <div class="flex justify-content-end">
                        <Button label="# Конвертация" size="small" severity="info" text class="p-1 text-xs" @click="setTransferDescriptionTemplate" />
                    </div>
                </div>
            </div>

            <template #footer>
                <Button label="Перевести" @click='exchange()' :disabled="transferDisabled || transferLoading" :loading="loading" severity="info"/>
            </template>
        </Dialog>
    </div>
    <Skeleton v-else height="1rem" class="border-round-lg"/>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import BigNumber from 'bignumber.js'

export default {
    props: ['wallet_id', 'currency', 'account'],
    data() {
        return {
            loading: false,
            displayTopup: false,
            topupAmount: 0,
            topupDescription: '',
            displayWithdraw: false,
            withdrawAmount: 0,
            withdrawDescription: '',
            displayTransfer: false,
            transferLoading: false,
            transferAmount: 0,
            transferReceiveAmount: 0,
            transferRate: 1,
            transferCommission: 0,
            transferDescription: '',
            fromWalletId: this.wallet_id,
            fromAccountId: this.account?.id || null,
            toAccountId: null,
            walletAccounts: [],
            walletData: null,
            finData: {
                articles: [],
                contractors: [],
            },
            is_save: false,
            finDataLoading: false,
            fidDataLoaded: false,
            selectedArticle: null,
            selectedContractor: null,
            systemWallets: [],
            addToAdesk: false,
            addToAdeskTopup: false,
            addToAdeskWithdraw: false,
            selectedArticleTopup: null,
            selectedContractorTopup: null,
            selectedArticleWithdraw: null,
            selectedContractorWithdraw: null,
        }
    },
    computed: {
        topupDisabled() {
            if (this.loading) return true
            if (!this.wallet_id) return true
            if (!this.topupAmount || isNaN(this.topupAmount) || this.topupAmount <= 0) return true
            if (this.hasFinId(this.wallet_id) && this.addToAdeskTopup && (!this.selectedArticleTopup || !this.selectedContractorTopup)) return true
            return false
        },
        withdrawDisabled() {
            if (this.loading) return true
            if (!this.wallet_id) return true
            if (!this.withdrawAmount || isNaN(this.withdrawAmount) || this.withdrawAmount <= 0) return true
            if (this.hasFinId(this.wallet_id) && this.addToAdeskWithdraw && (!this.selectedArticleWithdraw || !this.selectedContractorWithdraw)) return true
            return false
        },
        transferDisabled() {
            if (this.loading) return true
            if (!this.wallet_id || !this.fromAccountId || !this.toAccountId) return true
            if (!this.transferAmount || isNaN(this.transferAmount) || this.transferAmount <= 0) return true
            if (!this.transferRate || isNaN(this.transferRate) || this.transferRate <= 0) return true
            if (this.transferCommission === null || isNaN(this.transferCommission) || this.transferCommission < 0) return true
            return false
        },
        screenSize() { return this.$store.getters.StateScreenSize },
        contractorOptions() {
            if (!this.finData || !Array.isArray(this.finData.contractors)) return []
            return this.finData.contractors.map(c => ({
                label: c.title || c.name || c.label || c.code || String(c.id || c._id || ''),
                value: c.id || c._id || c.code || c.value || null,
            })).filter(o => o.value !== null)
        },
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
        currentAccount() {
            return this.account || null
        },
        currentAccountBalance() {
            const balance = Number(this.currentAccount?.balance)
            return Number.isFinite(balance) && balance > 0 ? balance : 0
        },
        fromAccountOption() {
            if (!this.currentAccount) return null
            return {
                id: this.currentAccount.id,
                label: this.buildAccountLabel(this.currentAccount),
            }
        },
        toAccountOptions() {
            return (this.walletAccounts || [])
                .filter(item => item && item.id && item.id !== this.fromAccountId)
                .map(item => ({
                    ...item,
                    label: this.buildAccountLabel(item),
                }))
        },
        selectedToAccount() {
            return this.toAccountOptions.find(item => item.id === this.toAccountId) || null
        },
        fromCurrencyCode() {
            return (this.currentAccount?.currency || this.currency || '').toUpperCase()
        },
        toCurrencyCode() {
            return (this.selectedToAccount?.currency || '').toUpperCase()
        },
        formattedTransferEffectiveRate() {
            const rate = this.getTransferEffectiveRate()
            if (!Number.isFinite(rate) || rate <= 0) return '-'
            return new BigNumber(rate).toFixed(8)
        },
        adminRates() {
            return this.$store.getters.StateAdminRates || []
        },
    },
    watch: {
        account: {
            immediate: true,
            handler(value) {
                this.fromAccountId = value?.id || null
                this.fromWalletId = value?.wallet_id || this.wallet_id
            }
        },
        transferAmount() {
            this.recalculateReceiveAmount()
        },
        transferRate() {
            this.recalculateReceiveAmount()
        },
        transferCommission() {
            this.recalculateReceiveAmount()
        },
        async toAccountId() {
            await this.updateRateByAccounts()
        }
    },
    methods: {
        articleOptions(type) {
            if (!this.finData || !Array.isArray(this.finData.articles)) return []
            return this.finData.articles.map(a => ({
                label: a.title || a.name || a.label || a.code || String(a.id || a._id || ''),
                value: a.id || a._id || a.code || a.value || null,
                type: a.type,
            })).filter(o => o.value !== null && o.type == type)
        },
        hasFinId(id) {
            if (!id) return false
            if (this.walletData && this.walletData.id === id) return !!this.walletData.fin_id
            return !!(this.systemWallets || []).find(w => w.id === id && w.fin_id)
        },
        isUserInGroup(type) {
            return true
        },
        async openPopup(type) {
            if (!type) return
            if (!this.fidDataLoaded) {
                await this.GetSystemWallets()
                this.fidDataLoaded = true
            }
            if (type === 'topup') this.displayTopup = true
            if (type === 'withdraw') this.displayWithdraw = true
            if (type === 'transfer') {
                this.displayTransfer = true
                await this.prepareTransfer()
            }
        },
        buildAccountLabel(account) {
            return `${String(account?.currency || '').toUpperCase()}`
        },
        normalizeRateValue(value) {
            const numeric = Number(value)
            return Number.isFinite(numeric) && numeric > 0 ? numeric : 1
        },
        setMaxWithdrawAmount() {
            this.withdrawAmount = this.currentAccountBalance
        },
        setMaxTransferAmount() {
            this.transferAmount = this.currentAccountBalance
        },
        setTransferCommission(value) {
            this.transferCommission = value
        },
        formatTemplateNumber(value, maxDecimals = 2) {
            const numeric = Number(value)
            if (!Number.isFinite(numeric)) return '0'

            // Для описания используем компактный формат без лишних нулей и с запятой.
            return new BigNumber(numeric)
                .toFixed(maxDecimals)
                .replace(/\.0+$/, '')
                .replace(/(\,\d*?)0+$/, '$1')
                .replace(/\.(\d*?)0+$/, '.$1')
                .replace(/\.$/, '')
                .replace('.', ',')
        },
        getCurrentDateLabel() {
            const now = new Date()
            const day = String(now.getDate()).padStart(2, '0')
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const year = now.getFullYear()
            return `${day}.${month}.${year}`
        },
        setTransferDescriptionTemplate() {
            const commissionFactor = this.getTransferCommissionFactor()
            const fromCurrency = this.fromCurrencyCode || '-'
            const toCurrency = this.toCurrencyCode || '-'
            const amount = this.formatTemplateNumber(this.transferAmount, 6)
            const rate = this.formatTemplateNumber(this.transferRate, 8)
            const factor = this.formatTemplateNumber(commissionFactor, 4)
            const receiveAmount = this.formatTemplateNumber(this.transferReceiveAmount, 6)
            const dateLabel = this.getCurrentDateLabel()
            const formula = `${amount}*(${rate}*${factor})`

            this.transferDescription = `Конвертация выручки: ${fromCurrency} ${formula}=${receiveAmount} ${toCurrency} за ${dateLabel}`
        },
        getTransferCommissionFactor() {
            const commission = Number(this.transferCommission)
            const ratio = Number.isFinite(commission) && commission >= 0 ? new BigNumber(commission).dividedBy(100) : new BigNumber(0)

            // Для деления комиссия увеличивает знаменатель, для умножения уменьшает множитель.
            return BigNumber.maximum(new BigNumber(1).minus(ratio), 0)
        },
        getTransferEffectiveRate() {
            const rate = Number(this.transferRate)
            if (!Number.isFinite(rate) || rate <= 0) return 0
            const commissionFactor = this.getTransferCommissionFactor()

            // Итоговый курс считаем с учетом направления конвертации и комиссии.
            return Number(new BigNumber(rate).multipliedBy(commissionFactor).toFixed(8))
        },
        recalculateReceiveAmount() {
            const amount = Number(this.transferAmount)
            const rate = this.getTransferEffectiveRate()
            if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(rate) || rate <= 0) {
                this.transferReceiveAmount = 0
                return
            }

            // Для обратных котировок используем деление, для прямых - умножение.
            this.transferReceiveAmount = Number(
                new BigNumber(amount).multipliedBy(rate).toFixed(6)
            )
        },
        async prepareTransfer() {
            this.transferLoading = true
            try {
                await this.loadWalletAccounts()
                this.transferAmount = 0
                this.transferReceiveAmount = 0
                this.transferRate = 1
                this.transferCommission = 0
                this.toAccountId = this.toAccountOptions.length === 1 ? this.toAccountOptions[0].id : null
                await this.ensureRatesLoaded()
                await this.updateRateByAccounts()
            } finally {
                this.transferLoading = false
            }
        },
        async loadWalletAccounts() {
            if (!this.wallet_id) return
            const response = await this.connect.GetAdminWallet(this.wallet_id).then(res => res)
            if (response && response.result && response.data) {
                this.walletData = response.data
                this.walletAccounts = Array.isArray(response.data.account_details)
                    ? response.data.account_details
                    : Array.isArray(response.data.accounts)
                        ? response.data.accounts
                        : []
                return
            }
            this.walletData = null
            this.walletAccounts = []
            this.showMess('error', 'Ошибка', 'Не удалось загрузить счета кошелька')
        },
        async ensureRatesLoaded() {
            if (this.adminRates.length > 0) return
            await this.$store.dispatch('ActionAdminRatesList', {
                limit: 200,
                skip: 0,
                filter: {},
                sort: {},
            })
        },
        getRateFromStore(fromCurrency, toCurrency) {
            return this.adminRates.find(rate => {
                return String(rate.from || '').toUpperCase() === String(fromCurrency || '').toUpperCase()
                    && String(rate.to || '').toUpperCase() === String(toCurrency || '').toUpperCase()
            }) || null
        },
        async updateRateByAccounts() {
            if (!this.fromCurrencyCode || !this.toCurrencyCode) {
                this.transferRate = 1
                this.recalculateReceiveAmount()
                return
            }
            if (this.fromCurrencyCode === this.toCurrencyCode) {
                this.transferRate = 1
                this.recalculateReceiveAmount()
                return
            }

            let rate = this.getRateFromStore(this.fromCurrencyCode, this.toCurrencyCode)
            if (!rate) {
                const response = await this.$store.dispatch('ActionAdminRatesList', {
                    limit: 1,
                    skip: 0,
                    filter: {
                        from: { value: this.fromCurrencyCode, matchMode: 'contains' },
                        to: { value: this.toCurrencyCode, matchMode: 'contains' },
                    },
                    sort: {},
                })
                rate = response?.data?.list?.[0] || null
            }

            this.transferRate = this.normalizeRateValue(rate?.last_value)
            this.recalculateReceiveAmount()
        },
        async getClipboardData() {
            try {
                return await navigator.clipboard.readText()
            } catch (err) {
                console.error('Failed to read clipboard contents:', err)
                return null
            }
        },
        put() {
            this.getClipboardData().then(data => {
                if (data && !isNaN(data) && data > 0) {
                    if (this.displayTopup) this.topupAmount = parseFloat(data)
                    if (this.displayWithdraw) this.withdrawAmount = parseFloat(data)
                    if (this.displayTransfer) this.transferAmount = parseFloat(data)
                }
            })
        },
        getClassByLabel(label) {
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label) {
            return this.helper.GetWalletNameByLabel(label)
        },
        showMess(severity, summary, detail) {
            try { this.$toast.add({ severity, summary, detail, life: 3000 }) }
            catch (e) { console.log('error showMess', e) }
        },
        async topup() {
            this.loading = true
            if (!this.wallet_id) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'ID кошелька не найден', life: 2000 })
                this.loading = false
                return
            }
            if (!this.currency) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Валюта кошелька не найдена', life: 2000 })
                this.loading = false
                return
            }
            try {
                const data = {
                    wallet_id: this.wallet_id,
                    amount: this.topupAmount,
                    currency_code: this.currency,
                    description: this.topupDescription || 'Пополнение кошелька админом',
                }
                const res = await this.connect.TopupWalletByAdmin(data)
                if (res && res.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Пополнение прошло успешно', life: 2000 })
                    this.displayTopup = false
                    this.topupAmount = 0
                    this.addToAdeskTopup = false
                    this.selectedArticleTopup = null
                    this.selectedContractorTopup = null
                } else {
                    if (res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', res.error ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Topup error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Сеть недоступна или внутренняя ошибка', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async withdraw() {
            this.loading = true
            try {
                const data = {
                    wallet_id: this.wallet_id,
                    amount: this.withdrawAmount,
                    currency_code: this.currency,
                    description: this.withdrawDescription || 'Списание средств админом',
                }
                const res = await this.connect.WithdrawWalletByAdmin(data)
                if (res && res.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Списание прошло успешно', life: 2000 })
                    this.displayWithdraw = false
                    this.withdrawAmount = 0
                    this.addToAdeskWithdraw = false
                    this.selectedArticleWithdraw = null
                    this.selectedContractorWithdraw = null
                } else {
                    if (res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', res.error ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Withdraw error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Сеть недоступна или внутренняя ошибка', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async exchange() {
            this.loading = true
            try {
                const data = {
                    wallet_id: this.wallet_id,
                    amount: this.transferAmount,
                    from_currency_code: this.currentAccount?.currency || this.currency,
                    to_currency_code: this.selectedToAccount?.currency || null,
                    exchange_rate: this.getTransferEffectiveRate(),
                    description: this.transferDescription || 'Перевод между счетами админом',
                }
                const res = await this.connect.ExchangeWallet(data)
                if (res && res.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Перевод выполнен успешно', life: 2000 })
                    this.displayTransfer = false
                    this.transferAmount = 0
                    this.transferReceiveAmount = 0
                    this.transferRate = 1
                    this.transferCommission = 0
                    this.toAccountId = null
                    this.selectedArticle = null
                    this.selectedContractor = null
                } else {
                    if (res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', res.error ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Exchange error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Сеть недоступна или внутренняя ошибка', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async GetSystemWallets() {
            if (!this.wallet_id) {
                this.systemWallets = []
                this.walletData = null
                this.walletAccounts = []
                return
            }
            const response = await this.connect.GetAdminWallet(this.wallet_id).then(res => res)
            if (response && response.result && response.data) {
                this.systemWallets = [response.data]
                this.walletData = response.data
                this.walletAccounts = Array.isArray(response.data.account_details)
                    ? response.data.account_details
                    : Array.isArray(response.data.accounts)
                        ? response.data.accounts
                        : []
                return
            }
            this.systemWallets = []
            this.walletData = null
            this.walletAccounts = []
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.fromWalletId = this.wallet_id
    },
}
</script>